<template>
  <div>
    <v-simple-table>
      <template v-slot:default>
        <thead>
        <tr>
          <th
            class='text-left'
            v-for='(header, index) in tableHeaders'
            :key="'header_' + index"
          >
            {{ header }}
          </th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="product in basketList" :key="'product_' + product.id">
          <td>
            <v-icon
              @click="removeProductFromBasket(product.id)"
              class="pointer"
            >mdi-close-circle
            </v-icon>
          </td>
          <td>{{ product.name }}</td>
          <td>
            <v-icon class="pointer"
                    @click="addToBasket(product.id)"
                    v-if="step === 1"
            >mdi-plus-circle-outline
            </v-icon>
            {{ product.quantity }}
            <v-icon class="pointer"
                    @click="takeFromBasket(product.id)"
                    v-if="step === 1"
            >mdi-minus-circle-outline
            </v-icon>
          </td>
          <td>{{ product.price }}</td>
          <td>{{ product.promotion }}</td>
          <td>{{ product.saving }}</td>
          <td>{{ product.toPay }}</td>
        </tr>
        </tbody>
      </template>
    </v-simple-table>
    <v-divider/>
    <v-row>
      <v-col cols="12" class="text-right">
        <strong>{{ text.pages.cart.cartTotalPrice }}:
          {{ totalPrice.toFixed(2) }} {{ text.common.currency }}</strong>
      </v-col>
    </v-row>
    <CartActionButtons :current-step="step" :view-step="viewStep"
                       v-on:back="$emit('back')"
                       v-on:confirm="$emit('confirm');
                       $store.commit('updateOrderData', {products: basket});
                       $store.commit('updateOrderData', {
                         totalAmount: $store.state.basketTotalPrice
                       });
                        "/>
  </div>
</template>

<script>
import Basket from '@/core/Basket';
import { translations } from '@/lang/translations';
import Axios from '@/core/Axios';
import CartActionButtons from '@/components/Pages/CartActionButtons.vue';
import { state, getters } from '../../store/index';

export default {
  name: 'CartTable',
  components: { CartActionButtons },
  props: ['currentStep'],
  data() {
    return {
      text: translations.pl,
      axios: new Axios(),
      basketList: [],
      basketClass: new Basket(),
      basket: this.$store.getters.getBasket,
      viewStep: 1,
    };
  },
  mounted() {
    this.getProductsDataById();
  },
  computed: {
    totalPrice() {
      return state.basketTotalPrice;
    },
    tableHeaders() {
      return this.text.pages.cart.tableHeaders;
    },
    basketQuantity() {
      return this.$store.state.basketQuantity;
    },
    step() {
      return this.currentStep;
    },
  },
  watch: {
    basketQuantity(newValue, oldValue) {
      this.basket = this.$store.getters.getBasket;
      this.getProductsDataById();
    },
  },
  methods: {
    removeProductFromBasket(productId) {
      this.basketClass.removeItemFromBasket(productId);
    },
    addToBasket(productId) {
      this.basketClass.increaseItemInBasket(productId);
    },
    takeFromBasket(productId) {
      this.basketClass.decreaseItemInBasket(productId);
    },
    getProductsDataById() {
      const idList = { idList: Object.keys(this.basket) };
      this.axios
        .makeCall('POST', 'norbit/product/getbasketdetails', idList)
        .then((response) => {
          if (response) {
            this.basketList = this.productDetailsToList(response);
          }
        })
        .catch((error) => {
          console.log('no ok');
        });
    },
    productDetailsToList(productDetails) {
      return Object.values(productDetails).map((product) => {
        const templist = {
          id: product.id,
          name: product.name,
          stock: product.stock,
          price: product.price ? product.price.toFixed(2) : '-',
          promotion: product.promotion ? product.promotion.toFixed(2) : '-',
          saving: (product.promotion && product.price) ? product.price - product.promotion : '-',
          toPay: product.promotion
            ? (product.promotion.toFixed(2) * this.basket[product.id].quantity).toFixed(2)
            : (product.price.toFixed(2) * this.basket[product.id].quantity).toFixed(2),
          quantity: this.basket[product.id].quantity,
        };
        return templist;
      });
    },
  },
};
</script>

<style scoped>
</style>
